import { Col, Row } from 'react-bootstrap';
import { nbsp } from '../../tools/formatting';

export interface HpBasicHeadingControlProps {
  heading: string;
  subheading: string | null;
}

export function BasicHeadingControl({ heading, subheading }: HpBasicHeadingControlProps): JSX.Element {
  return (
    <Row>
      <Col xs={12} className="hp-heading-control">
        <h1>{heading}</h1>
        {subheading && <div aria-hidden={subheading === nbsp}>{subheading}</div>}
      </Col>
    </Row>
  );
}
